// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611051018/js/" + chunkId + "." + {"44":"dc55837c","225":"984e93ce","481":"0f43e8df","486":"4f051d52","770":"b508d09e"}[chunkId] + ".0.29071056965952713.chunk.js";
};